import { FC } from 'react';
import type { VirtualItem } from '@tanstack/react-virtual';
import type { DataTableColumn } from '@/components/UI/DataTableV2/DataTable.model';
import { CellTypeRouter } from './CellTypeRouter';
import { useDataTable } from '../DataTableProvider';

interface VirtualizedCellsProps {
  virtualRows: Array<VirtualItem>;
  virtualColumns: Array<VirtualItem>;
  scrollableColumns: Array<DataTableColumn>;
}

export const VirtualizedCells: FC<VirtualizedCellsProps> = ({ virtualRows, virtualColumns, scrollableColumns }) => {
  const { dataTableService } = useDataTable();

  return (
    <>
      {virtualRows.map((virtualRow) => {
        return virtualColumns.map((virtualColumn) => {
          const column = scrollableColumns[virtualColumn.index];
          const columnIndex = dataTableService.toIndexColumn(column.id);

          if (columnIndex === undefined) {
            return null;
          }

          return (
            <CellTypeRouter
              key={`${column.id}-${virtualRow.index}`}
              coordinate={{ column: columnIndex, row: virtualRow.index }}
              positionOffset={{
                x: virtualColumn.start,
                y: virtualRow.start,
              }}
            />
          );
        });
      })}
    </>
  );
};
